export const PAGE_404 = {
  title: 'What planet are <span>we on?</span>',
  subtitle: 'Looks like the page you were headed to no longer exists.',
  button_label: 'Go Home',
};
